var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadComponent && _vm.data.AttNotValid === '0')?_c(_vm.loadComponent,{tag:"component",attrs:{"button-state":_vm.buttonState,"data":_vm.data,"root-data":_vm.rootData,"update-node-key":_vm.updateNodeKey},on:{"button-state":_vm.onChangeButtonState,"click-item":function($event){return _vm.onClickItem(_vm.data)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }